<template>
  <div
    v-if="rooms.length > 1"
    class="text-center"
  >
    <v-radio-group
      :value="roomId"
    >
      <template v-slot:label>
        <h6 class="text-h6">{{ $t('settings.rooms.title') }}</h6>
      </template>

      <v-radio
        key="all"
        value="all"
        :label="$t('settings.rooms.all_rooms')"
        @click="$router.push(`/`)"
      />

      <v-radio
        v-for="room in rooms"
        :key="room.id"
        :value="room.id"
        :label="room.name"
        @click="$router.push(`/room-${room.id}`)"
      />

    </v-radio-group>

    <v-divider />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('common', ['rooms']),
    ...mapState('route', ['params']),
    roomId() {
      return this.params.roomId ? Number(this.params.roomId) : 'all'
    }
  },
}
</script>
